import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useQuery, useMutation } from '@apollo/client';
import { Section, SectionItem, SectionName } from '../components/Chrome';
import Loader from '../components/Loader';
import Toggle from '../components/Toggle';
import { useToast } from '../components/Toast';
import { VIEWER } from '../utilities/queries';
import { TOGGLE_NIGHT_MODE } from '../utilities/mutations';

const SettingsAppearancePage = () => {
  const { data } = useQuery(VIEWER);
  const [loadingNightMode, setLoadingNightMode] = useState(false);
  const [toggleNightMode] = useMutation(TOGGLE_NIGHT_MODE);

  const toast = useToast();

  return (
    <>
      <Helmet>
        <title>Appearance</title>
      </Helmet>
      <Section>
        {!data ? (
          <Loader />
        ) : (
          <>
            <SectionName isSecondLevel>Appearance</SectionName>
            <SectionItem>
              <Toggle
                checked={data.viewer.nightMode}
                onClick={async () => {
                  setLoadingNightMode(true);
                  try {
                    await toggleNightMode();
                  } catch (error) {
                    toast({ children: error.message });
                  }
                  setLoadingNightMode(false);
                }}
                disabled={loadingNightMode}
              >
                Night mode
              </Toggle>
            </SectionItem>
          </>
        )}
      </Section>
    </>
  );
};

export default SettingsAppearancePage;
